/**
 * Inventory Store
 *
 * @since 2021-11-18
 * @author Jaeuk Ryu <wj_tams_dev02>
 *
 */
import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  tamsLogUrl: '/api/sm/external/tams_log_send',
  settingApi: '/monitor/setup/logs',
  optionApi: '/options',
  logInfoList: [],
  defaultList: [],
  optionList: []
})

export const mutations = {
  clearStore: (state) => {
    state.logInfoList = []
    state.defaultList = []
    state.optionList = []
  },
  getLoadSetDatas: (state, data) => {
    state.defaultList = _.cloneDeep(data)
    state.logInfoList = _.cloneDeep(state.defaultList)
  }
}

export const actions = {
  // 로그 설정 조회
  async getLoadSetDatas ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.tamsLogUrl, {}, {loading: false, loadingShow: false, loadingHide: false})
      return resultFactory(commit, {length: null, data: data, action: 'getLoadSetDatas', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 로그 설정 적용
  async applySettings ({commit, state}, payload) {
    const apiUrl = `${state.tamsLogUrl}/apply`
    try {
      const result = await this.$axios.$put(apiUrl, {items: payload}, {loading: true, loadingShow: true, loadingHide: false, applyMsg: true})
      if (result.code !== 'ok') {
        return {code: 'fail'}
      }
      // state.defaultList = _.cloneDeep(state.logInfoList)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 로그 설정 취소
  async cancelSettings ({commit, state}) {
    const apiUrl = `${state.tamsLogUrl}/cancel`
    try {
      const result = await this.$axios.$put(apiUrl, null, {loading: true, loadingShow: true, loadingHide: false, cancelMsg: true})
      if (result.code !== 'ok') {
        return false
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
  // async setLogSettings ({commit, state}, updateList) {
  //   let result = {}
  //   let apiUrl = `${state.apiPreFix}${state.settingApi}`
  //   try {
  //     result = await this.$axios.$put(apiUrl, {items: updateList}, {loading: false, successAlert: false})
  //     return result
  //   } catch (e) {
  //     result.code = 'nok'
  //     result.reason = e
  //     return result
  //   }
  // },
  // // 로그 설정 option 조회
  // async getLogOptions ({commit, state}, logId) {
  //   let result = {}
  //   let apiUrl = `${state.apiPreFix}${state.settingApi}/${logId}${state.optionApi}`
  //   try {
  //     result = await this.$axios.$get(apiUrl)
  //     if (result.code === 'ok') {
  //       state.optionList = result.result
  //     } else {
  //       state.optionList = []
  //     }
  //
  //     return result
  //   } catch (e) {
  //     result.code = 'nok'
  //     result.reason = e
  //     state.optionList = []
  //     return result
  //   }
  // },
  // // 경고 프로세스 설정 수정
  // async setLogOptions ({commit, state}, param) {
  //   let result = {}
  //   let apiUrl = `${state.apiPreFix}${state.settingApi}/${param.logId}${state.optionApi}`
  //   try {
  //     result = await this.$axios.$put(apiUrl, {items: param.updateList})
  //     if (result.code === 'ok') {
  //       state.chgProcessList = param.updateList
  //     } else {
  //       state.chgProcessList = []
  //     }
  //
  //     return result
  //   } catch (e) {
  //     result.code = 'nok'
  //     result.reason = e
  //     return result
  //   }
  // }
}

export const getters = {

}
export const strict = false
